import { InputItem } from "../data";

export const fipayTransferSteps = [
  { path: "payment-details", label: "Payment Details" },
  { path: "schedule-transfer", label: "Schedule Transfer" },
  { path: "summary", label: "Summary" },
  { path: "confirmation", label: "Confirmation" },
];

export const inputs: InputItem[] = [
  {
    name: "RecipientTag",
    type: "text",
    label: "Recipient's Tag",
    placeholder: "@",
    hasTransactionFee: false,
    hasBeneficiary: true,
    accountName: true,
  },
  {
    name: "Amount",
    type: "number",
    label: "Amount",
    placeholder: "$0.00",
    hasTransactionFee: true,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "Purpose",
    type: "text",
    label: "Purpose of Transaction (Optional)",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
];

export const paymentSummary = [
  {
    title: "Amount sent",
    key: "Amount",
  },
  {
    title: "Recipient tag",
    key: "RecipientTag",
  },
  {
    title: "Transaction fee",
    key: "TransactionFee",
  },
  {
    title: "Transaction type",
    key: "TransactionType",
  },
  {
    title: "Schedule Transfer",
    key: "period",
  },
  {
    title: "Purpose",
    key: "Purpose",
  },
];
